import React from 'react';
import { Clock } from 'lucide-react';
import { formatEstimatedTime } from '../../../utils/timeUtils';

interface QueueInfoProps {
  queuePosition: number;
  estimatedWaitMinutes: number;
  variant?: 'detailed' | 'compact';
  className?: string;
}

const QueueInfo: React.FC<QueueInfoProps> = ({
  queuePosition,
  estimatedWaitMinutes,
  variant = 'detailed',
  className = '',
}) => {
  if (variant === 'compact') {
    return (
      <div className={`flex items-center text-sm text-amber-700 ${className}`}>
        <svg className="flex-shrink-0 mr-1.5 h-4 w-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
        </svg>
        In queue (#{queuePosition}) - ~{formatEstimatedTime(estimatedWaitMinutes)} wait
      </div>
    );
  }

  return (
    <div></div>
    // <div className={`text-center py-4 mx-6 mb-4 bg-amber-50 border border-amber-200 rounded-lg ${className}`}>
    //   <div className="flex justify-center mb-2">
    //     <ClockIcon className="h-8 w-8 text-amber-600" />
    //   </div>
    //   <h4 className="text-md font-medium text-amber-900 mb-1">
    //     Your search is in queue
    //   </h4>
    //   <p className="text-sm text-amber-700">
    //     Waiting for another search to complete. You're #{queuePosition} in line.
    //     <br />
    //     <span className="font-medium">
    //       Estimated wait time to start: approximately {formatEstimatedTime(estimatedWaitMinutes)}
    //     </span>
    //   </p>
    // </div>
  );
};

export default QueueInfo; 